import { render, staticRenderFns } from "./FuncionarioGestionGlobal.vue?vue&type=template&id=6a067d7a&"
import script from "./FuncionarioGestionGlobal.vue?vue&type=script&lang=js&"
export * from "./FuncionarioGestionGlobal.vue?vue&type=script&lang=js&"
import style0 from "./FuncionarioGestionGlobal.vue?vue&type=style&index=0&id=6a067d7a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports